var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpellCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M571.3 281c-6.25-6.25-16.37-6.25-22.62 0l-192.3 192.3l-105-105c-6.25-6.25-16.37-6.25-22.62 0s-6.25 16.38 0 22.62l116.4 116.4C348.2 510.4 352.3 512 356.4 512c4.094 0 8.187-1.562 11.31-4.688l203.6-203.6C577.6 297.4 577.6 287.3 571.3 281zM222.7 233.7l-95.1-224c-5.031-11.78-24.37-11.78-29.41 0l-95.1 224c-3.484 8.109 .2812 17.52 8.406 21c8.078 3.5 17.52-.25 20.1-8.406L53.98 192h116l23.27 54.3C195.9 252.4 201.8 256 208 256c2.109 0 4.25-.4062 6.297-1.297C222.4 251.2 226.2 241.8 222.7 233.7zM67.69 160l44.31-103.4L156.3 160H67.69zM272 256h103.1c39.7 0 71.1-32.3 71.1-72c0-31.03-19.73-57.55-47.33-67.64C410.3 104.1 416 88.72 416 72c0-39.7-32.3-72-71.1-72H272C263.2 0 256 7.156 256 16v224C256 248.8 263.2 256 272 256zM288 32h55.1c22.06 0 39.1 17.94 39.1 40S366.1 112 344 112h-55.1V32zM288 144h87.1c22.06 0 39.1 17.94 39.1 40S398.1 224 376 224h-87.1V144z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpellCheck);
export default __webpack_public_path__ + "static/media/spell-check.7d53bc9070b14e31523e1c870a316da4.svg";
export { ForwardRef as ReactComponent };